import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { unsyncedBookingsCount, initiateOrdersSync } from "@/services/sync-service";
import { ref, onMounted, defineComponent } from "vue";
import { LogLevel, LogService } from "@/services/logging";
import Timeout from "await-timeout";
import { useI18n } from "vue-i18n";
export default defineComponent({
  name: "SyncInProgress",
  emits: ["sync-success"],
  setup: function setup(_, _ref) {
    var emit = _ref.emit;

    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var visible = ref(true);
    var progress = ref(0);
    var syncMessage = ref(t("sync.instructions"));
    var totalBookings = ref(0);
    var remainingBookings = ref(0);
    var retryInterval = 10000; // 10 seconds between checks

    var maxDuration = 10 * 60 * 1000; // 5 minutes

    var syncTimer = null;

    function finishSync(success) {
      if (syncTimer) {
        clearInterval(syncTimer);
        syncTimer = null;
      }

      if (success) {
        syncMessage.value = t("sync.status.success");
        progress.value = 100; // Only hide the popup when successful

        setTimeout(function () {
          visible.value = false;
          emit("sync-success", true);
        }, 500);
      } else {
        syncMessage.value = t("sync.status.failure"); // Emit the failure event

        setTimeout(function () {
          visible.value = false;
          emit("sync-success", false);
        }, 1000);
        LogService.info("Sync failed after trying for ".concat(maxDuration / 1000, " seconds. ").concat(remainingBookings.value, " bookings still need to be synchronized."));
      }
    }

    function startSyncLoop() {
      return _startSyncLoop.apply(this, arguments);
    }

    function _startSyncLoop() {
      _startSyncLoop = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var startTime;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                startTime = Date.now(); // Reset sync state when starting/retrying

                progress.value = 0;
                syncMessage.value = t("sync.instructions");
                syncTimer = window.setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                  var elapsed, synced;
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          elapsed = Date.now() - startTime;

                          if (!(elapsed >= maxDuration)) {
                            _context.next = 7;
                            break;
                          }

                          _context.next = 4;
                          return unsyncedBookingsCount();

                        case 4:
                          remainingBookings.value = _context.sent;
                          finishSync(remainingBookings.value === 0);
                          return _context.abrupt("return");

                        case 7:
                          _context.prev = 7;
                          _context.next = 10;
                          return initiateOrdersSync();

                        case 10:
                          _context.next = 12;
                          return Timeout.set(2000);

                        case 12:
                          _context.next = 14;
                          return unsyncedBookingsCount();

                        case 14:
                          remainingBookings.value = _context.sent;

                          if (!(remainingBookings.value === 0)) {
                            _context.next = 18;
                            break;
                          }

                          finishSync(true);
                          return _context.abrupt("return");

                        case 18:
                          // Update progress
                          synced = totalBookings.value - remainingBookings.value;
                          progress.value = Math.min(Math.floor(synced / totalBookings.value * 100), 99);
                          _context.next = 25;
                          break;

                        case 22:
                          _context.prev = 22;
                          _context.t0 = _context["catch"](7);
                          LogService.info("Sync: error when syncing orders", {
                            params: _context.t0
                          }, LogLevel.Error);

                        case 25:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[7, 22]]);
                })), retryInterval);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _startSyncLoop.apply(this, arguments);
    }

    function initializeSync() {
      return _initializeSync.apply(this, arguments);
    }

    function _initializeSync() {
      _initializeSync = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return unsyncedBookingsCount();

              case 2:
                totalBookings.value = _context3.sent;
                remainingBookings.value = totalBookings.value;

                if (totalBookings.value === 0) {
                  finishSync(true);
                } else {
                  startSyncLoop();
                }

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _initializeSync.apply(this, arguments);
    }

    onMounted(function () {
      initializeSync();
    });
    return {
      visible: visible,
      progress: progress,
      syncMessage: syncMessage,
      totalBookings: totalBookings,
      remainingBookings: remainingBookings
    };
  }
});